import { useEffect, useRef, useState } from 'react';

import ArrowToggle from '../icons/ArrowToggle';

type Props = {
    title: string;
    content: string[];
};

export const InfoDropdown: React.FC<Props> = ({ content, title }) => {
    const [toggleDropdown, setToggleDropdown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // close when clicking outside
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setToggleDropdown(false);
            }
        }

        if (toggleDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggleDropdown]);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setToggleDropdown((prev) => !prev)}
                className="flex items-center gap-2 py-1.5 min-w-[140px] w-full text-blue"
            >
                {title}
                <ArrowToggle color="%230098cc" isOpen={toggleDropdown} />
            </button>
            {toggleDropdown && (
                <div
                    className="absolute left-0 w-full z-50 bg-white shadow-md border border-stroke"
                    id="dropdown-button-3"
                >
                    <ul>
                        {content.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    className={`w-full pt-2 pl-2 pr-2 ${
                                        index + 1 === content.length ? 'pb-2' : ''
                                    } text-left cursor-pointer text-grey`}
                                >
                                    {item}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}
        </div>
    );
};
